var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"setting":_vm.setting,"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }